import moment from 'moment';
import types from '../actions/types';

const initialState = {
  storingen: null,
  loading: false
};


function filterStoringenOnSearchText(storingen, searchText) {
  const lowerCaseSearchText = searchText.toString().toLowerCase();
  const containsSearchText = (str) => (
    str && str.toLowerCase().indexOf(lowerCaseSearchText) !== -1
  );

  return storingen.filter(storing => (
    containsSearchText(storing.header) ||
    containsSearchText(storing.description) ||
    (storing.routes && storing.routes.some(route => (
      (route.route_short_name && route.route_short_name.toString() === lowerCaseSearchText) ||
      containsSearchText(route.route_long_name)
    ))) ||
    (storing.stops && storing.stops.some(stop => (
      containsSearchText(stop.Description) ||
      (stop.ReplacedBy && (
        containsSearchText(stop.ReplacedBy.Description) ||
        containsSearchText(stop.ReplacedBy.Remark)
      ))
    )))
  ));
}

function filterStoringenOnDate(storingen, date) {
  const dateStart = moment(`${date}T00:00:00`, 'DD-MM-YYYYTHH:mm:ss');
  const dateEnd = moment(dateStart).add('days', 1).add('hours', 4);
  return storingen.filter(storing => {
    const storingStart = moment(storing.start_time, 'YYYY-MM-DDTHH:mm:ssZ');
    const storingEnd = moment(storing.end_time, 'YYYY-MM-DDTHH:mm:ssZ');
    return (storingEnd >= dateStart && storingStart < dateEnd);
  });
}

export default (state = initialState, action) => {
  switch (action.type) {
    case types.REQUEST_STORINGEN:
      return Object.assign({}, state, {
        loading: true
      });
    case types.REQUEST_STORINGEN_FAILED:
      return initialState;
    case types.RECEIVED_STORINGEN:
      let storingen = action.storingen;

      //Remove duplicate alerts
      storingen = storingen.reduce((list, storing) => {
        if(!list.some(item => item.alert_id === storing.alert_id)) {
          list.push(storing);
        }
        return list;
      }, [])
      
      if (action.formValues.searchText) {
        storingen = filterStoringenOnSearchText(storingen, action.formValues.searchText);
      }
      if(action.formValues.date) {
        storingen = filterStoringenOnDate(storingen, action.formValues.date);
      }

      return {
        storingen,
        loading: false
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/storingen.js